module.exports = __webpack_public_path__ + "img/ogp_casa_big.c318c797.jpg";